import React from 'react'
import { Box } from 'reflexbox'
import { TextField, IconButton, Icon } from '@rapidapi/ui-lib'
import styled from 'themes'
import { css } from '@emotion/core'

type JsonInputFilterType = {
  onChange: (value: string) => void
  onClear: (e: React.MouseEvent) => void
  keyword: string
}

const InputContainer = styled(Box)(
  ({
    theme: {
      addAlpha,
      colors: { backgrounds },
    },
  }) =>
    css({
      position: 'absolute',
      left: 0,
      bottom: 0,
      zIndex: 1000,
      width: '100%',
      boxShadow: `0 -32px 28px -8px ${addAlpha(backgrounds.primary, 0.95)}`,
      backgroundColor: backgrounds.primary,
    }),
)

const placeholder = 'JsonPath expressions e.g. $.store.book[0].title'
const JsonInputFilter: React.FC<JsonInputFilterType> = ({
  keyword = '',
  onChange,
  onClear,
}) => (
  <InputContainer px={6} pt={4} pb={4}>
    <TextField
      value={keyword}
      width="100%"
      onChange={onChange}
      hint={placeholder}
      placeholder="Filter expression..."
      startAdornment={<Icon symbol="filter" />}
      endAdornment={
        <IconButton
          icon="close"
          size="small"
          onClick={onClear}
          disabled={keyword.trim() === ''}
        />
      }
    />
  </InputContainer>
)

export default JsonInputFilter
